import React from 'react'
import Caixa from './pages/pedidos_mk/caixa.jsx'
import SemMovimentacao from './pages/Relatorios/SemMovimentacao.jsx'
import OrderAguardando from './pages/Ag.Faturamento/ag.fat.jsx'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import LockScreen from './components/LockScreen/LockScreen.jsx'
import { AjusteEstoque } from './pages/AjusteEstoque/index.jsx'
import Anuncios from './pages/Anuncios/anuncio.jsx'
import Metrics from './pages/Anuncios/recharts.jsx'
import BlingIntegrationRequest from './pages/Bling/Auth.jsx'
import PedidosList from './pages/Bling/listaPedidos.jsx'
import Boletos from './pages/boletos/boletos.jsx'
import AberturaCaixa from './pages/Caixa/abertura.jsx'
import { CategoriesSubcategories } from './pages/CategoriesSubcategories/index.jsx'
import { Checkout } from './pages/Checkout/index.jsx'
import ClaimsAdmin from './pages/Claims/ClaimsAdmin.jsx'
import { EditarCliente } from './pages/Clientes/EditarCliente/index.jsx'
import { Clientes } from './pages/Clientes/ListarClientes/index.jsx'
import { NovoCliente } from './pages/Clientes/NovoCliente/index.jsx'
import { ConsultarHeranca } from './pages/ConsultarHeranca/index.jsx'
import { ConsultarSaldo } from './pages/ConsultarSaldo/index.jsx'
import { ConsultarTransferencias } from './pages/ConsultarTransferencias/index.jsx'
import EditarContas from './pages/contas_a_pagar/contas_a_pagar-editar.jsx'
import AccountTable from './pages/contas_a_pagar/ContasAPagar.jsx'
import EditarContasReceber from './pages/contas_a_receber/contas_a_receber-editar.jsx'
import AccountTableReceber from './pages/contas_a_receber/ContasAReceber.jsx'
import CentroDeCusto from './pages/Custo/custo.jsx'
import Dashboard from './pages/dashboard/dashboard.jsx'
import OrderDetails from './pages/DetalhesPedido/detalhespedido.jsx'
import DevolucoesETrocas from './pages/devolucoes/devolucoes.jsx'
import { EditarPedidoCompra } from './pages/EditarPedidoCompra/index.jsx'
import { EditarProduto } from './pages/EditarProduto/index.jsx'
import ImportacaoProdutos from './pages/Erpflex/importaproduto.jsx'
import PendingStockTransactions from './pages/Erpflex/sincronizacoes.jsx'
import PendingEnterTransactions from './pages/Erpflex/sincronizacoesentrada.jsx'
import EstoqueProduto from './pages/estoqueproduto/estoqueproduto.jsx'
import ExportacaoMercadoLivre from './pages/exportacaoanuncios/exportar.jsx'
import { FAQ } from './pages/FAQ/index.jsx'
import Financial from './pages/Faturamento/Relatorio.jsx'
import { Funcionarios } from './pages/Funcionarios/index.jsx'
import HomePage from './pages/homepage/homepage.jsx'
import ImportExcel from './pages/ImportarEstoques/importStock.jsx'
import { ImportarPedidosLeroy } from './pages/ImportarPedidosLeroy/index.jsx'
import { ImportarProdutos } from './pages/ImportarProdutos/index.jsx'
import { ImportarProdutosBling } from './pages/ImportProdutosBling/index.jsx'
import { Integracoes } from './pages/Integracoes/index.jsx'
import Inventories from './pages/Inventories/index.jsx'
import { ListarOrcamentos } from './pages/ListarOrcamentos/index.jsx'
import LocationViewer from './pages/Locate/LocateViewer.jsx'
import AdDetails from './pages/log_anuncios/log.jsx'
import Login from './pages/login/login.jsx'
import MagaluAuthentication from './pages/magalu/authMagalu.jsx'
import Marcas from './pages/Marcas/marcas.jsx'
import EtiquetasEnvio from './pages/MercadoLIvre/Impressao.jsx'
import { MercadoLivrePedidos } from './pages/MercadoLivrePedidos/index.jsx'
import FinanceScreen from './pages/MercadoPago/mercadopago.jsx'
import ListaNFe from './pages/nfe/nfe.jsx'
import EdicaoNFe from './pages/nfe/nfeedicao.jsx'
import NfeEntrada from './pages/nfeentrada/nfeentrada.jsx'
import ImportarNFeModerna from './pages/NfeEntradaImportada/importarNfe.jsx'
import { NotFoundPage } from './pages/NotFoundPage/index.jsx'
import { NovoPedidoCompra } from './pages/NovoPedidoCompra/index.jsx'
import { NovoProduto } from './pages/NovoProduto/index.jsx'
import OrcamentoEditar from './pages/orcamento/orcamento-editar.jsx'
import Orcamentos from './pages/orcamento/orcamento.jsx'
import OrderMercadoLibre from './pages/OrderMercadoLibre/MercadoLibre.jsx'
import PendingOrders from './pages/OrdersNotChecked/index.jsx'
import PackList from './pages/packlist/packlist.jsx'
import PedidoEditar from './pages/pedido-editar/pedido-editar.jsx'
import PedidoCompra from './pages/PedidoCompra/pedidocompra.jsx'
import PedidoMK from './pages/pedidos_mk/pedidos-editar.jsx'
import OrderListM from './pages/pedidos_mk/pedidos.jsx'
import Pedidos from './pages/pedidos_real_time/pedidos.jsx'
import { PedidosCompra } from './pages/PedidosCompra/index.jsx'
import Perguntas from './pages/perguntas/perguntas.jsx'
import Precificacao from './pages/precificacao/precificacao.jsx'
import PricesTable from './pages/prices_anuncios/price.jsx'
import { Produtos } from './pages/Produtos/produto.jsx'
import ProdutosML from './pages/ProdutosML/index.jsx'
import ItemList from './pages/produtosporpedido/prod-pedido.jsx'
import { Reclamacoes } from './pages/Reclamacoes/index.jsx'
import RelatorioReservaEstoque from './pages/Relatorios/rel_reserva.jsx'
import { RelatorioEstoqueMinimo } from './pages/Relatorios/RelatorioEstoqueMinimo.jsx'
import RelatorioProdutos from './pages/RelProdutos/RelProdutos.jsx'
import Resumo from './pages/resumo/resumo.jsx'
import WithdrawalScreen from './pages/Retiradas/retiradas.jsx'
import RelatorioRT from './pages/Rt/rt.jsx'
import { ShopeeAuthentication } from './pages/ShopeeAuthentication/index.jsx'
import { SignatureOrder } from './pages/SignatureOrder/index.jsx'
import Site from './pages/site/site.jsx'
import Sku from './pages/sku/sku.jsx'
import { TransferenciaEstoque } from './pages/TransferenciaEstoque/index.jsx'
import { TrocasDevolucoes } from './pages/TrocasDevolucoes/index.jsx'
import VendasRelatorio from './pages/VendasRelatorio/VendasRelatorio.jsx'
import { AjustarEstoqueEndereco } from './pages/Wms/AjustarEstoqueEndereco/index.jsx'
import { WMSBonus } from './pages/Wms/Bonus/index.jsx'
import { Embalagens } from './pages/Wms/Embalagens/index.jsx'
import { WMSEnderecos } from './pages/Wms/Enderecos/index.jsx'
import { Motivos } from './pages/Wms/Motivos/index.jsx'
import Os from './pages/Wms/OS/index.jsx'
import { WMSProdutos } from './pages/Wms/Produtos/index.jsx'
import { WMSTransferenciaEndereco } from './pages/Wms/TransferenciaEndereco/index.jsx'
import { WMSTransferenciaPicking } from './pages/Wms/TransferenciaPicking/index.jsx'
import PrivateRoutes from './utils/PrivateRoutes.jsx'
//import DashboardVendasRegiao from './pages/mapas/mapasdecalor.jsx'
import { AjusteComposicao } from './pages/AjustesComposicao/index.jsx'
import ComprasRelatorios from './pages/Anuncios/relatorios/compras.jsx'
import ContasList from './pages/armazens/armazens.jsx'
import { AuthCodes } from './pages/AuthCodes/index.jsx'
import DashboardVendasRegiao from './pages/mapas/mapasdecalor.jsx'
import ProdutoDetalhes from './pages/MercadoLIvre/anuncios.jsx'
import CurvaABCPDFGenerator from './pages/MercadoLIvre/cruvaabc.jsx'
import AnunciosListing from './pages/MercadoLIvre/seller_central.jsx'
import { MercadoLivreCalculoLucros } from './pages/MercadoLivreCalculoLucros/index.jsx'
import NfeListagem from './pages/nfeentrada/listanfe.jsx'
import PacklistDashboard from './pages/pedidos_mk/packlist.jsx'
import KitCreator from './pages/Produtos/kitcreate.jsx'
import { RelatorioSeparacaoPorData } from './pages/Relatorios/RelatorioSeparacaoPorData.jsx'
import ChatApp from './pages/whatsapp/wpp.jsx'
import { CodigoOperacaoTipoOS } from './pages/Wms/CodigoOperacaoTipoOS/index.jsx'
import { WMSGerenciarInventario } from './pages/Wms/GerenciarInventario/index.jsx'
import { WMSInventarios } from './pages/Wms/Inventarios/index.jsx'
import { WMSNovoInventario } from './pages/Wms/NovoInventario/index.jsx'
import { WMSRelatorios } from './pages/Wms/Relatorios/index.jsx'
import WavePickingSystem from './pages/pedidos_mk/WavePickingSystem.jsx'
import { SalesDashboard as Relvendas } from './pages/Relatorios/relvendas.jsx'
import { RepresentantesComerciais } from './pages/RepresentantesComerciais/index.jsx'
import Produtividade from './pages/Produtividade/produtividade.jsx'
import { ComissoesRepresentante } from './pages/ComissoesRepresentante/index.jsx'
import { PedidosPorCliente } from './pages/PedidosPorCliente/index.jsx'
import ItemsShopee from './pages/Shopee/Itemsshopee .jsx'

function Rotas() {
  PrivateRoutes(false)

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="*"
          element={<NotFoundPage />}
        />
        <Route
          path="/leroymerlin/importar/pedidos"
          element={<ImportarPedidosLeroy />}
        />
        <Route
          path="/consultar-transferencias"
          element={<ConsultarTransferencias />}
        />
        <Route
          path="/mapa/vendas"
          element={<DashboardVendasRegiao />}
        />
        <Route
          path="/chat"
          element={<ChatApp />}
        />
        <Route
          path="/packlist"
          element={<PacklistDashboard />}
        />
        <Route
          path="/wms/os"
          element={<Os />}
        />
        <Route
          path="/wms/bonus"
          element={<WMSBonus />}
        />
        <Route
          path="/caixa/diario"
          element={<Caixa />}
        />
        <Route
          path="/wms/separacao"
          element={<WavePickingSystem />}
        />
        <Route
          path="/meli/produtos/:produtoId?"
          element={<ProdutoDetalhes />}
        />
        <Route
          path="/shopee/items"
          element={<ItemsShopee />}
        />
        <Route
          path="/relatorios/sem_movimentacoes"
          element={<SemMovimentacao />}
        />
        <Route
          path="/meli/seller"
          element={<AnunciosListing />}
        />
        <Route
          path="/produtos/kitcreator"
          element={<KitCreator />}
        />
        <Route
          path="/meli/seller/curvaabc"
          element={<CurvaABCPDFGenerator />}
        />
        <Route
          path="/precificacao"
          element={<Precificacao />}
        />

        <Route
          path="/anuncios/log"
          element={<AdDetails />}
        />

        <Route
          path="/consultar-heranca"
          element={<ConsultarHeranca />}
        />
        <Route
          path="/localizacao"
          element={<LocationViewer />}
        />
        <Route
          path="/armazens-virtuais"
          element={<ContasList />}
        />
        <Route
          path="/signature-order"
          element={<SignatureOrder />}
        />
        <Route
          path="/relatorios/compras"
          element={<ComprasRelatorios />}
        />
        <Route
          path="/bling/nfe"
          element={<ImportarNFeModerna />}
        />
        <Route
          path="/lista/nfe-entrada"
          element={<NfeListagem />}
        />
        <Route
          path="/ajuste-estoque"
          element={<AjusteEstoque />}
        />
        <Route
          path="/relatorios/relatorio-vendas"
          element={<Relvendas />}
        />
        <Route
          path="/contas-a-receber"
          element={<AccountTableReceber />}
        />
        <Route
          path="/produtosml"
          element={<ProdutosML />}
        />
        <Route
          path="/itens"
          element={<ItemList />}
        />
        <Route
          path="produtos/importar/bling"
          element={<ImportarProdutosBling />}
        />
        <Route
          path="relatorios/vendedor"
          element={<VendasRelatorio />}
        />

        <Route
          path="/relatorio/faturamento"
          element={<Financial />}
        />

        <Route
          path="/pedido-compra"
          element={<PedidoCompra />}
        />
        <Route
          path="/clientes"
          element={<Clientes />}
        />
        <Route
          path="/marcas"
          element={<Marcas />}
        />
        <Route
          path="/boletos"
          element={<Boletos />}
        />
        <Route
          path="/integracoes"
          element={<Integracoes />}
        />
        <Route
          path="/produtos/reserva"
          element={<RelatorioReservaEstoque />}
        />
        <Route
          path="relatorios/produtos/relprodutos"
          element={<RelatorioProdutos />}
        />
        <Route
          path="/produtos/estoque-minimo"
          element={<RelatorioEstoqueMinimo />}
        />
        <Route
          path="/produtos/importarEstoque"
          element={<ImportExcel />}
        />
        <Route
          path="/pedidosMercadoLibre/:pack?"
          element={<OrderMercadoLibre />}
        />
        <Route
          path="/anuncios/dados"
          element={<Metrics />}
        />
        <Route
          path="/caixa/abertura"
          element={<AberturaCaixa />}
        />
        <Route
          path="/reclamacoes"
          element={<Reclamacoes />}
        />

        <Route
          path="/lock"
          element={<LockScreen />}
        />

        <Route
          path="/clientes/novo"
          element={<NovoCliente />}
        />
        <Route
          path="/home"
          element={<HomePage />}
        />
        <Route
          path="/clientes/editar/:id"
          element={<EditarCliente />}
        />
        <Route
          path="/orcamento/:conta/novo"
          element={<Orcamentos />}
        />
        <Route
          path="/faq"
          element={<FAQ />}
        />
        <Route
          path="/trocas-e-devolucoes"
          element={<TrocasDevolucoes />}
        />
        <Route
          path="/produtividade"
          element={<Produtividade />}
        />
        <Route
          path="/resumo"
          element={<Resumo />}
        />
        <Route
          path="/consultar-saldo"
          element={<ConsultarSaldo />}
        />
        <Route
          path="/orders_aguardando"
          element={<OrderAguardando />}
        />
        <Route
          path="/orcamento/:conta/:id_pedido/:print?"
          element={<OrcamentoEditar />}
        />
        <Route
          path="/bling/:code?/:state?"
          element={<BlingIntegrationRequest />}
        />
        <Route
          element={<CategoriesSubcategories />}
          path="/categorias-subcategorias"
        />
        <Route
          path="/nfe.entrada/:nota/account/:id_conta"
          element={<NfeEntrada />}
        />
        <Route
          path="/login"
          element={<Login />}
        />
        <Route
          path="/relatorios/separacao-por-data"
          element={<RelatorioSeparacaoPorData />}
        />
        <Route
          path="/estoque/:id_produto/account/:id_conta"
          element={<EstoqueProduto />}
        />
        <Route
          path="/pedido/:idpedido/:id_conta"
          element={<OrderDetails />}
        />
        <Route
          element={<Site />}
          path="/site"
          exact
        />

        <Route element={<PrivateRoutes />}>
          <Route
            element={<Dashboard />}
            path="/"
            exact
          />
          <Route
            path="/produtos/centrodecustos"
            element={<CentroDeCusto />}
          />
          <Route
            path="/pedido/editar/:id_pedido?"
            element={<PedidoMK />}
          />
          <Route
            path="/funcionarios"
            element={<Funcionarios />}
          />
          <Route
            path="/mercadolivre/anuncios"
            element={<Anuncios />}
          />
          <Route
            path="/pedidos/novo"
            element={<PedidoEditar />}
          />
          <Route
            path="/mercadolivre/exportar"
            element={<ExportacaoMercadoLivre />}
          />
          <Route
            path="/mercadolivre/auth-codes"
            element={<AuthCodes />}
          />
          <Route
            path="/mercadolivre/calculo-lucros"
            element={<MercadoLivreCalculoLucros />}
          />
          <Route
            path="/contasapagar"
            element={<AccountTable />}
          />
          <Route
            path="/sku"
            element={<Sku />}
          />
          <Route
            path="/pedidos/editar/:id_pedido"
            element={<PedidoEditar />}
          />
          <Route
            path="/checkout"
            element={<Checkout />}
          />
          <Route
            path="/inventario"
            element={<Inventories />}
          />
          <Route
            path="/devolucoes"
            element={<DevolucoesETrocas />}
          />
          <Route
            path="/contasapagar/editar/:idConta"
            element={<EditarContas />}
          />
          <Route
            path="/contasreceber/editar/:idConta"
            element={<EditarContasReceber />}
          />
          <Route
            path="/contasapagar/novo"
            element={<EditarContas />}
          />
          <Route
            path="/realtime"
            element={<Pedidos />}
          />
          <Route
            path="/contasreceber/novo"
            element={<EditarContasReceber />}
          />
          <Route
            path="/mercadolivre/pedidos"
            element={<MercadoLivrePedidos />}
          />
          <Route
            path="/mercadopago"
            element={<FinanceScreen />}
          />
          <Route
            path="/expedicao"
            element={<WithdrawalScreen />}
          />
          <Route
            path="/orcamentos"
            element={<ListarOrcamentos />}
          />
          <Route
            path="/produtos"
            element={<Produtos />}
          />
          <Route
            path="/representantes-comerciais"
            element={<RepresentantesComerciais />}
          />
          <Route
            path="/pedidos/PendingOrders"
            element={<PendingOrders />}
          />
          <Route
            path="/produtos/novo"
            element={<NovoProduto />}
          />
          <Route
            path="/produtos/ajuste-composicao"
            element={<AjusteComposicao />}
          />
          <Route
            path="/produtos/:idProduto"
            element={<EditarProduto />}
          />
          <Route
            path="/magalu"
            element={<MagaluAuthentication />}
          />
          <Route
            path="/shopee"
            element={<ShopeeAuthentication />}
          />
          <Route
            path="/pedidos/packlist"
            element={<PackList />}
          />
          <Route
            path="/etiquetas/impressao"
            element={<EtiquetasEnvio />}
          />
          <Route
            path="/rt"
            element={<RelatorioRT />}
          />
          <Route
            path="/perguntas/:idPergunta?"
            element={<Perguntas />}
          />
          <Route
            path="/tranferencia-estoque"
            element={<TransferenciaEstoque />}
          />
          <Route
            path="/pedidos-compra"
            element={<PedidosCompra />}
          />
          <Route
            path="novo/pedido-compra"
            element={<NovoPedidoCompra />}
          />
          <Route
            path="/pedidos/cliente"
            element={<PedidosPorCliente />}
          />
          <Route
            path="/pedidos-compra/:id"
            element={<EditarPedidoCompra />}
          />
          <Route
            path="/mercadolivre/prices"
            element={<PricesTable />}
          />
          <Route
            path="/relatorios/comissoes-representante"
            element={<ComissoesRepresentante />}
          />
          <Route
            path="/pedidos/marktplaces"
            element={<OrderListM />}
          />
          <Route
            path="/importar-produtos"
            element={<ImportarProdutos />}
          />
          <Route
            path="/erpflex/importar/produtos"
            element={<ImportacaoProdutos />}
          />
          <Route
            path="/erpflex/sincronizacoes/produtos"
            element={<PendingStockTransactions />}
          />
          <Route
            path="/erpflex/sincronizacoes/entrada/produtos"
            element={<PendingEnterTransactions />}
          />
          <Route
            path="/wms/enderecos"
            element={<WMSEnderecos />}
          />
          <Route
            path="/wms/relatorios"
            element={<WMSRelatorios />}
          />
          <Route
            path="/wms/tranferencia-endereco"
            element={<WMSTransferenciaEndereco />}
          />
          <Route
            path="/wms/tranferencia-picking"
            element={<WMSTransferenciaPicking />}
          />
          <Route
            path="/wms/produtos"
            element={<WMSProdutos />}
          />
          <Route
            path="/wms/inventarios"
            element={<WMSInventarios />}
          />
          <Route
            path="/wms/inventarios/novo"
            element={<WMSNovoInventario />}
          />
          <Route
            path="/wms/inventarios/:id"
            element={<WMSGerenciarInventario />}
          />
          <Route
            path="/wms/motivos"
            element={<Motivos />}
          />
          <Route
            path="/wms/codoper-tipoos"
            element={<CodigoOperacaoTipoOS />}
          />
          <Route
            path="/wms/embalagens"
            element={<Embalagens />}
          />
          <Route
            path="/wms/ajustar/enderecos"
            element={<AjustarEstoqueEndereco />}
          />
          <Route
            path="/listagem/nfe"
            element={<ListaNFe />}
          />
          <Route
            path="/nfe/editar/:idnfe/:contaempresa?"
            element={<EdicaoNFe />}
          />
          <Route
            path="/claims"
            element={<ClaimsAdmin />}
          />
          <Route
            path="/bling/listar"
            element={<PedidosList />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default Rotas
